import styled, { keyframes } from 'styled-components';

const spinner = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Root = styled.div`
  width: 100% !important;
  height: 100% !important;
  position: relative;
`;

export const Loader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  pointer-events: none;
`;

export const Logo = styled.div`
  width: 115px;
  height: 115px;
  object-fit: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;

  & img {
    object-fit: contain;
    height: 100%;
    width: 100%;
  }
`;

export const Spinner = styled.div`
  min-width: 150px;
  min-height: 150px;
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;

  &::after {
    content: ' ';
    display: block;
    width: 100%;
    height: 100%;
    margin: 0;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #fff;
    border-color: var(--color-secondary) transparent var(--color-secondary) transparent;
    animation: ${spinner} 1.2s linear infinite;
    top: 0;
    left: 0;
  }
`;

export const IframeStyled = styled.iframe<any>`
  html body img {
    height: 100%;
    width: 100%;
  }
`;
